
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import  reportMsgUt from "@/util/reportMsg";
    import {useRoute, useRouter} from "vue-router";

    interface State {
        isNoDefect: ComputedRef<boolean>; // 是否为无火烧无泡水无重大事故的车
        point: ComputedRef<"N" | "Y">; // N 没有三种缺陷 Y 有三种缺陷
        isAccident: number; // 0不是事故车 1是事故车
        isFire: number; // 0不是事故车 1是事故车
        isWater: number; // 0不是事故车 1是事故车
        reportCode: string | null; 
        channelType: string;
        logoUrl: string;
        protectTime: string;
        promiseMsg: string;
        reportMsg: object;
        templateCode: string;
    }

    export default defineComponent({
        name: "headTip",
        setup() {
            const {query} = useRoute();
            let state: State = reactive({
                isNoDefect: false as any,
                point: "Y" as any,
                isAccident: 1,
                isFire: 1,
                isWater: 1,
                reportCode: '',
                channelType: `${query.channelType}` || '',
                logoUrl: '',
                protectTime: '90',
                promiseMsg: '',
                reportMsg: {},
                templateCode: ''
            })
            state.reportMsg = reportMsgUt;
            state.reportCode = `${query.reportCode}`;
            state.templateCode = `${query.templateCode}`;
            state.protectTime = state.channelType === 'jiaxuan' ? '100' : '90';
            // 获取路由器实例
            const router = useRouter()
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            state.promiseMsg = `268V承诺${state.protectTime}天内错检回购`;
            if (state.reportMsg['Rp699']()) {
                state.promiseMsg = `268V承诺${state.protectTime}天内错检回购</br>重要部件错检赔付`;
            } else if (state.reportMsg['RpHC']()){
                state.promiseMsg = `268V承诺${state.protectTime}天内错检赔付`;
            }
            watch(dataInfo,(data: any) => {
                const {isAccident, isFire, isWater, reportConfigInfo} = data;
                state.logoUrl = reportConfigInfo ? reportConfigInfo.logoUrl : '';
                state.isNoDefect = computed(() => {
                    return isAccident === 0 && isFire === 0 && isWater === 0
                })
                state.point = computed(() => {
                    return state.isNoDefect ? 'N' : 'Y'
                })
                state.isAccident = isAccident
                state.isFire = isFire
                state.isWater = isWater
            })
            return {
                state,
                router
            }
        },
        methods: {
            toExplain(desc){
                if(desc === 'auth') {
                    this.router.push({
                        path: '/explainFreeAuth',
                        query: {
                            templateCode: this.state.templateCode
                        }
                    })
                } else {
                    this.router.push({
                        path: '/explainFreeCheck',
                        query: {
                            channelType: this.state.channelType,
                            templateCode: this.state.templateCode
                        }
                    })
                }
            }
        }
    })
